import { Form, InputNumber } from '@arco-design/web-react'
import InstantSwitch from '../InstantSwitch'
import SettingSectionCard from '../SettingSectionCard'
import type { OptionsAPI } from '../useOptions'

const KEYS = ['grok.violation_deduction_enabled', 'grok.violation_deduction_amount']

export default function GrokModelSection({ options }: { options: OptionsAPI }) {
  const { getNumber, patch } = options

  return (
    <SettingSectionCard title="Grok 模型" keys={KEYS} options={options}>
      <Form layout="vertical">
        <div className="grid md:grid-cols-2 gap-3">
          <Form.Item label="违规扣费开关">
            <InstantSwitch options={options} optionKey="grok.violation_deduction_enabled" defaultChecked />
          </Form.Item>
          <Form.Item label="违规扣费金额">
            <InputNumber
              style={{ width: 240 }}
              min={0}
              step={0.01}
              value={getNumber('grok.violation_deduction_amount', 0.05)}
              onChange={(v) => patch({ 'grok.violation_deduction_amount': v ?? 0.05 })}
            />
          </Form.Item>
        </div>
      </Form>
    </SettingSectionCard>
  )
}
